/**
 * useResilience - 복원력 시스템 통합 훅
 *
 * ISSUE_045: 연결 복원력 시스템의 React 인터페이스
 * ISSUE_073: 미사용 훅 제거, useResilienceInitializer만 유지
 *
 * @module core/resilience/hooks/useResilience
 */

import { useEffect } from 'react';
import { startResilienceSystem, stopResilienceSystem } from '../ResilienceCoordinator';
import { useAuthStore } from '~/core/store/useAuthStore';
import { useSyncEnabled } from '~/core/store/useSyncStore';
import { isSupabaseConfigured } from '~/shared/lib/supabase';

/**
 * 복원력 시스템 초기화 훅
 *
 * root.tsx에서 한 번만 사용
 */
export function useResilienceInitializer(): void {
  const isInitialized = useAuthStore((state) => state.isInitialized);
  const syncEnabled = useSyncEnabled();

  useEffect(() => {
    // 조건 체크
    if (!isInitialized) return;
    if (!isSupabaseConfigured()) return;
    // ISSUE_068: Sync OFF → 네트워크 복원력 시스템 불필요
    if (!syncEnabled) return;

    startResilienceSystem();

    return () => {
      stopResilienceSystem();
    };
  }, [isInitialized, syncEnabled]);
}
